import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StaticContentRoutingModule } from './static-content-routing.module';
import { StaticPageComponent } from './static-page/static-page.component';


@NgModule({
  declarations: [
    StaticPageComponent
  ],
  imports: [
    CommonModule,
    StaticContentRoutingModule
  ]
})
export class StaticContentModule { }
